import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class FolderNotFoundGitError extends GitError {
  constructor(folderPath: string, append = true) {
    super(append ? `Folder at "${folderPath}" does not exist` : folderPath);
  }

  readonly gitErrorCode = GitErrorStatusCode.FolderNotFound;
}
